import { useEffect, useRef, useCallback } from 'react';

function useEventListener(eventName, handler, element = window) {
  const savedHandler = useRef();

  useEffect(() => {
    savedHandler.current = handler;
  }, [handler]);

  useEffect(() => {
    const isSupported = element && element.addEventListener;
    if (!isSupported) return;

    const eventListener = (event) => savedHandler.current(event);
    element.addEventListener(eventName, eventListener);

    return () => {
      element.removeEventListener(eventName, eventListener);
    };
  }, [eventName, element]);
}

export function useModalClose(onClose, enabled = true) {
  const handler = useCallback(
    (event) => {
      if (!enabled || !onClose) return;
      if (event.keyCode === 27 || event.keyCode === 8) {
        event.preventDefault();
        event.stopPropagation();
        onClose();
      }
    },
    [onClose, enabled]
  );

  useEventListener('keydown', handler, window);
}

